import React from "react";
import LegalPageLayout, { LegalSection } from "../components/LegalPageLayout";
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE } from "../constants/contact";

export default function Terms() {
  return (
    <LegalPageLayout
      title="Kullanım"
      highlight="Koşulları"
      subtitle="TV13 web sitesini kullanırken geçerli olan kurallar ve yükümlülükler."
      image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
    >
      <LegalSection title="1. Genel">
        <p>
          Bu Kullanım Koşulları, TV13 (“Platform”, “biz”) tarafından sunulan web sitesi ve dijital
          yayın hizmetlerinin kullanımına ilişkin şartları belirler. Siteye erişerek bu koşulları
          kabul etmiş sayılırsınız.
        </p>
        <p>
          Platform, Ayla Şimşek Danışmanlık Şirketi bünyesinde işletilir. Adres: {CONTACT_ADDRESS}.
        </p>
      </LegalSection>

      <LegalSection title="2. Hizmetin Kapsamı">
        <p>
          TV13; canlı yayınlar, program videoları, haber ve bilgilendirme içerikleri sunar. İçerikler
          zaman zaman güncellenebilir, kaldırılabilir veya teknik nedenlerle geçici olarak
          erişilemez olabilir.
        </p>
        <p>
          Platform, kesintisiz veya hatasız hizmet taahhüdü vermez; bakım, güncelleme veya mücbir
          sebep hallerinde hizmet geçici olarak durdurulabilir.
        </p>
      </LegalSection>

      <LegalSection title="3. Kullanıcı Yükümlülükleri">
        <ul className="list-disc pl-5 space-y-2">
          <li>Siteyi yalnızca yasal amaçlarla ve bu koşullara uygun şekilde kullanmak</li>
          <li>İçerikleri izinsiz kopyalamak, çoğaltmak veya ticari amaçla dağıtmak yasaktır</li>
          <li>Site güvenliğini tehdit eden, zararlı yazılım yayan veya sisteme müdahale eden davranışlardan kaçınmak</li>
          <li>İletişim formu ve diğer alanlarda doğru ve güncel bilgi vermek</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. İçerik ve Telif Hakları">
        <p>
          Sitedeki tüm metin, görsel, video, logo ve tasarım unsurları TV13 veya lisans verenlerine
          aittir. Yazılı izin olmaksızın ticari kullanım, yeniden yayın veya değiştirilmiş şekilde
          paylaşım yasaktır.
        </p>
        <p>
          Üçüncü taraf platformlara (ör. YouTube) yönlendirilen içerikler, ilgili platformların
          kendi kullanım koşullarına tabidir.
        </p>
      </LegalSection>

      <LegalSection title="5. Üçüncü Taraf Bağlantılar">
        <p>
          Sitede üçüncü taraf web sitelerine veya sosyal medya hesaplarına bağlantılar
          bulunabilir. Bu sitelerin içeriği ve politikaları üzerinde kontrolümüz yoktur; ziyaret
          ettiğiniz harici sitelerin koşullarını incelemenizi öneririz.
        </p>
      </LegalSection>

      <LegalSection title="6. Sorumluluk Sınırı">
        <p>
          Platform üzerindeki bilgiler genel bilgilendirme amaçlıdır. İçeriklerdeki hata veya eksiklikler
          nedeniyle doğabilecek doğrudan veya dolaylı zararlardan, teknik arızalardan veya veri
          kaybından TV13 sorumlu tutulamaz.
        </p>
      </LegalSection>

      <LegalSection title="7. Değişiklikler">
        <p>
          Bu Kullanım Koşulları gerektiğinde güncellenebilir. Güncel metin her zaman bu sayfada
          yayımlanır. Değişiklik sonrası siteyi kullanmaya devam etmeniz, yeni koşulları kabul
          ettiğiniz anlamına gelir.
        </p>
      </LegalSection>

      <LegalSection title="8. İletişim">
        <p>Kullanım koşulları hakkında sorularınız için:</p>
        <ul className="list-none space-y-1">
          <li>E-posta: {CONTACT_EMAIL}</li>
          <li>Telefon: {CONTACT_PHONE}</li>
          <li>Adres: {CONTACT_ADDRESS}</li>
        </ul>
      </LegalSection>
    </LegalPageLayout>
  );
}
